"use strict";
/* PNavi library
 *
 *  PNavi library has one class named PNavi.
 *
 *  This library depends on Knockoutjs so before import this library you need import both Knockoutjs.
 *  We no longer depend on JQuery.
 *
 *  Asukoe Partners Inc. all rights reserved
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ko = __importStar(require("knockout"));
var PNaviAnswer = /** @class */ (function () {
    function PNaviAnswer() {
        this.answerText = "";
        this.nextid = "";
    }
    return PNaviAnswer;
}());
var PNaviAnswerEx = /** @class */ (function (_super) {
    __extends(PNaviAnswerEx, _super);
    // support of IE, instead of using Object.assign, added copy constructor to PNaviQuestionEx
    function PNaviAnswerEx(a) {
        var _this = _super.call(this) || this;
        _this.selected = ko.observable(false);
        _this.question = null;
        _this.answerText = a.answerText;
        _this.nextid = a.nextid;
        _this.selected(a.selected ? a.selected() : false);
        _this.question = a.question ? a.question : null;
        return _this;
    }
    return PNaviAnswerEx;
}(PNaviAnswer));
var PNaviQuestion = /** @class */ (function () {
    function PNaviQuestion() {
        this.type = "question";
        this.id = "";
        this.questionText = "";
        this.answers = [];
    }
    return PNaviQuestion;
}());
var PNaviQuestionEx = /** @class */ (function (_super) {
    __extends(PNaviQuestionEx, _super);
    // support of IE, instead of using Object.assign, added copy constructor to PNaviQuestionEx
    function PNaviQuestionEx(q) {
        var _this = _super.call(this) || this;
        _this.order = 0;
        if (q) {
            _this.type = q.type;
            _this.id = q.id;
            _this.questionText = q.questionText;
            _this.answers = [];
            q.answers.forEach(function (answer) {
                _this.answers.push(new PNaviAnswerEx(answer));
            });
        }
        return _this;
    }
    return PNaviQuestionEx;
}(PNaviQuestion));
var PNaviResult = /** @class */ (function () {
    function PNaviResult() {
        this.type = "result";
        this.id = "";
        this.title = "";
        this.content = "";
    }
    return PNaviResult;
}());
var PNaviBasicInfo = /** @class */ (function () {
    function PNaviBasicInfo() {
        this.rootId = "";
    }
    return PNaviBasicInfo;
}());
var PNaviData = /** @class */ (function () {
    function PNaviData() {
        this.basicInfo = new PNaviBasicInfo();
        this.questionResult = [];
    }
    return PNaviData;
}());
var PNaviOptions = /** @class */ (function () {
    function PNaviOptions() {
    }
    return PNaviOptions;
}());
// definition of default element tree for PNavi
var PNaviDefaultElements = {
    type: "div",
    classes: ["pnavi-container"],
    children: [
        {
            type: "div",
            classes: ["pnavi-questions"],
            bind: "foreach: { data: questions, afterRender: $root.questionAdded}",
            children: [
                {
                    type: "div",
                    classes: ["pnavi-question"],
                    children: [
                        {
                            type: "div",
                            classes: ["pnavi-question-order"],
                            bind: "text: order",
                        },
                        {
                            type: "div",
                            classes: ["pnavi-question-text"],
                            bind: "html: questionText",
                        },
                        {
                            type: "ul",
                            classes: ["pnavi-answers"],
                            bind: "foreach: answers",
                            children: [
                                {
                                    type: "li",
                                    classes: ["pnavi-answer"],
                                    bind: "css: {selected: selected}, event: { click: $root.answerClicked }",
                                    children: [
                                        {
                                            type: "div",
                                            classes: ["pnavi-answer-text"],
                                            bind: "text: answerText"
                                        },
                                        {
                                            type: "div",
                                            classes: ["pnavi-answer-nextid"],
                                            bind: "text: nextid"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            type: "div",
            classes: ["pnavi-results"],
            bind: "foreach: {data: result, afterRender: $root.resultAdded}",
            children: [
                {
                    type: "div",
                    classes: ["pnavi-result"],
                    children: [
                        {
                            type: "div",
                            classes: ["pnavi-result-content"],
                            bind: "html: content"
                        }
                    ]
                }
            ]
        }
    ]
};
var PNavi = /** @class */ (function () {
    function PNavi() {
        var _this = this;
        this.top = null;
        this.qr = [];
        this.questions = ko.observableArray();
        this.result = ko.observableArray();
        this.qrMap = new Map();
        this.root = "";
        this.beforeQuestionCallback = null;
        this.beforeResultCallback = null;
        // Start procedure navi, this is usually called when "START" is clicked
        this.start = function () {
            _this.questions.removeAll();
            _this.result.removeAll();
            var rootNode = _this.qrMap.get(_this.root);
            if (rootNode) {
                _this.goNext(rootNode);
            }
        };
        // Event handler for answer clicked
        this.answerClicked = function (d) {
            var _a;
            var reselect = false;
            (_a = d.question) === null || _a === void 0 ? void 0 : _a.answers.forEach(function (answer) {
                if (answer.selected()) {
                    answer.selected(false);
                    reselect = true;
                }
            });
            if (reselect) {
                while (_this.questions().length > d.question.order) {
                    _this.popQuestion();
                }
                _this.result.removeAll();
            }
            d.selected(true);
            var next = _this.qrMap.get(d.nextid);
            if (next) {
                _this.goNext(next);
            }
        };
        // called when a question is added
        this.questionAdded = function (d) {
            _this.triggerCustomEvent("questionadded", "");
        };
        // called when a result added
        this.resultAdded = function (d) {
            _this.triggerCustomEvent("resultadded", "");
        };
        this.qrMap = new Map();
    }
    // Load procedure navi data
    PNavi.prototype.init = function (data, top, option) {
        var _this = this;
        this.top = top;
        // load procedure navi data from given url
        this.qr = data.questionResult;
        this.root = data.basicInfo.rootId;
        this.qrMap = new Map();
        // create question/result map to look up next question/result
        this.qr.forEach(function (item) {
            _this.qrMap.set(item.id, item);
        });
        // Process options
        if (option) {
            if (option.generateDefault == undefined || option.generateDefault == true) {
                top.appendChild(this.generateElements(PNaviDefaultElements));
            }
            else {
                for (var i = 0; i < PNavi.bindingMap.length; i++) {
                    var targets = this.top.querySelectorAll(PNavi.bindingMap[i][0]);
                    if (targets) {
                        for (var j = 0; j < targets.length; j++) {
                            targets[j].setAttribute("data-bind", PNavi.bindingMap[i][1]);
                        }
                    }
                }
            }
            if (option.beforeQuestion) {
                this.beforeQuestionCallback = option.beforeQuestion;
            }
            if (option.beforeResult) {
                this.beforeResultCallback = option.beforeResult;
            }
        }
        else {
            top.appendChild(this.generateElements(PNaviDefaultElements));
        }
        this.triggerCustomEvent("binding", "");
        var a = this.questions();
        ko.applyBindings(this, top);
        this.triggerCustomEvent("bound", "");
        return this;
    };
    // generate default element tree
    PNavi.prototype.generateElements = function (definition) {
        var _this = this;
        var el = document.createElement(definition.type);
        if (definition.classes) {
            definition.classes.forEach((function (cls) {
                el.classList.add(cls);
            }));
        }
        if (definition.bind) {
            el.setAttribute("data-bind", definition.bind);
        }
        if (definition.children) {
            definition.children.forEach(function (child) {
                el.appendChild(_this.generateElements(child));
            });
        }
        return el;
    };
    PNavi.prototype.triggerCustomEvent = function (name, value) {
        if (this.top) {
            var customEvent = void 0;
            if (typeof window.CustomEvent === "function") {
                customEvent = new CustomEvent(name, {
                    detail: {
                        value: value
                    },
                    bubbles: true
                });
            }
            else {
                customEvent = document.createEvent('CustomEvent');
                customEvent.initCustomEvent(name, true, true, {
                    detail: {
                        value: value
                    }
                });
            }
            this.top.dispatchEvent(customEvent);
        }
    };
    // Get all questions and results read from data file
    PNavi.prototype.getQuestions = function () {
        return this.qr;
    };
    // Get asked questions (question stack)
    PNavi.prototype.getSelectedQuestions = function () {
        return this.questions;
    };
    // push given question to question stack
    PNavi.prototype.pushQuestion = function (q) {
        // support of IE, instead of using Object.assign, added copy constructor to PNaviQuestionEx
        // let qx: PNaviQuestionEx = Object.assign(new PNaviQuestionEx(), q);
        var qx = new PNaviQuestionEx(q);
        qx.order = this.questions().length + 1;
        qx.answers.forEach(function (answer) {
            answer.selected = ko.observable(false);
            answer.question = qx;
        });
        if (this.beforeQuestionCallback) {
            this.questions.push(this.beforeQuestionCallback(qx));
        }
        else {
            this.questions.push(qx);
        }
    };
    // pop a question from the question stack
    PNavi.prototype.popQuestion = function () {
        return this.questions.pop();
    };
    // returns last question in the question stack
    PNavi.prototype.lastQuestion = function () {
        if (this.questions.length > 0) {
            return this.questions()[this.questions.length - 1];
        }
        else {
            return null;
        }
    };
    PNavi.prototype.goNext = function (qr) {
        if (qr.type === "question") {
            this.pushQuestion(qr);
        }
        else {
            if (this.beforeResultCallback) {
                this.result.push(this.beforeResultCallback(qr));
            }
            else {
                this.result.push(qr);
            }
        }
    };
    PNavi.bindingMap = [
        [".pnavi-questions", "foreach: { data: questions, afterRender: $root.questionAdded}"],
        [".pnavi-question-order", "text: order"],
        [".pnavi-question-text", "html: questionText"],
        [".pnavi-answers", "foreach: answers"],
        [".pnavi-answer", "css: {selected: selected}, event: { click: $root.answerClicked }"],
        [".pnavi-answer-text", "text: answerText"],
        [".pnavi-answer-nextid", "text: nextid"],
        [".pnavi-results", "foreach: {data: result, afterRender: $root.resultAdded}"],
        [".pnavi-result-content", "html: content"],
    ];
    return PNavi;
}());
exports.PNAVI = new PNavi();
window.PNAVI = exports.PNAVI;
